var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSparkleinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.499 19.499"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.749 19.499a.75.75 0 01-.721-.544l-.779-2.727a7.208 7.208 0 00-4.979-4.979L.543 10.47a.75.75 0 010-1.442l2.727-.779A7.208 7.208 0 008.249 3.27L9.028.543a.75.75 0 011.442 0l.779 2.727a7.208 7.208 0 004.979 4.979l2.727.779a.75.75 0 010 1.442l-2.727.779a7.208 7.208 0 00-4.979 4.979l-.779 2.727a.75.75 0 01-.721.544zm-6.27-9.75l.2.058a8.7 8.7 0 016.009 6.009l.058.2.058-.2a8.7 8.7 0 016.009-6.009l.2-.058-.2-.058a8.7 8.7 0 01-6.009-6.009l-.055-.202-.058.2a8.7 8.7 0 01-6.009 6.009z",
    fill: "currentColor"
  })));
}

export default SvgSparkleinline;